module.exports = __webpack_public_path__ + "static/media/benequer2.b3d8eb7b.jpg";